
import React, { Component } from 'react';
import Cookies from "js-cookie";
import screenfull from 'screenfull';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Menu, Icon, Layout, Popover } from 'antd';
import UpdatePasswords from '../../page/pages/UpdatePasword';
import UpdatePayPasswords from '../../page/pages/UpdatePayPasword';

import avater from '../../style/imgs/user.png';
import SiderCustom from '../../layout/slideMenu/SiderCustom';
import { logout } from "../../reducer/config.redux";
import {isPlatform} from "../../utils";

const { Header } = Layout;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class HeaderCustom extends Component {
    state = {
        visible: false,
        updatePasswordStatus: false,
        updatePayPasswordStatus:false
    };

    screenFull = () => {
        if (screenfull.enabled) {
            screenfull.request();
        }
    };

    updatePassword = () => { //修改密码
        this.setState({
            updatePasswordStatus: !this.state.updatePasswordStatus
        });
        if (!this.state.updatePasswordStatus) {
            this.update.reset()
        }
    }
    updatePayPassword = () =>{
        this.setState({
            updatePayPasswordStatus: !this.state.updatePayPasswordStatus
        });
        if (!this.state.updatePayPasswordStatus) {
            this.updatePay.reset()
        }
    }

    logout = () => {
        this.props.logout();
        let loginData = Cookies.get('loginData');
        if (loginData) {
            Cookies.remove('loginData');

            sessionStorage.setItem('login_out_path', '/admin/finance/detailed');

            loginData = JSON.parse(loginData); //根据不同的登录身份返回不同的登录页面
            if (loginData.merchantId) {
                this.props.history.push('/merchantLogin');
            } else {
                this.props.history.push('/login');
            }
        }
    };
    popoverHide = () => {
        this.setState({
            visible: false,
        });
    };
    handleVisibleChange = (visible) => {
        this.setState({ visible });
    };
    render() {
        const { isMobile } = this.props.config;
        let loginData = Cookies.get('loginData');

        if (loginData) {
            loginData = JSON.parse(loginData);
        }

        return (
            <div>
                <Header style={{ background: '#fff', padding: 0, height: 65 }} className="custom-theme" >
                    {
                        isMobile ?
                            <Popover content={<SiderCustom popoverHide={this.popoverHide} collapsed={isMobile} />} trigger="click" placement="bottomLeft" visible={this.state.visible} onVisibleChange={this.handleVisibleChange}>
                                <Icon type="bars" className="trigger custom-trigger" />
                            </Popover>
                            :
                            <Icon
                                className="trigger custom-trigger"
                                type={this.props.collapsed ? 'menu-unfold' : 'menu-fold'}
                                onClick={this.props.toggle}
                            />

                    }
                    <Menu
                        mode="horizontal"
                        style={{ lineHeight: '64px', float: 'right' }}
                    >
                        <Menu.Item key="full" onClick={this.screenFull} >
                            <Icon type="arrows-alt" onClick={this.screenFull} />
                        </Menu.Item>
                        <SubMenu title={<span className="avatar"><img src={avater} alt="头像" /><i className="on bottom b-white" /></span>}>
                            <MenuItemGroup title="用户中心">
                                <Menu.Item key="setting:1">你好 - {loginData ? loginData.name : ''}</Menu.Item>
                                <Menu.Item key="updatePassword1" onClick={this.updatePassword}>修改密码</Menu.Item>
                                {isPlatform()?<Menu.Item key="updatePassword2" onClick={this.updatePayPassword}>修改支付密码</Menu.Item>:null}
                                <Menu.Item key="logout" onClick={this.logout}><span>退出登录</span></Menu.Item>
                            </MenuItemGroup>
                        </SubMenu>
                    </Menu>
                    <style>{`
                    .ant-menu-submenu-horizontal > .ant-menu {
                        width: 120px;
                        left: -40px;
                    }
                `}</style>
                </Header>
                <UpdatePayPasswords updatePayPasswordStatus={this.state.updatePayPasswordStatus} onRef={ref => this.updatePay = ref} clickUpdate={this.updatePayPassword} />
                <UpdatePasswords updatePasswordStatus={this.state.updatePasswordStatus} onRef={ref => this.update = ref} clickUpdate={this.updatePassword} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return state
};
const mapActionToProps = { logout }

export default withRouter(connect(mapStateToProps, mapActionToProps)(HeaderCustom));



// WEBPACK FOOTER //
// ./src/layout/headerCustom/HeaderCustom.jsx